import MultiSelectComponent from "../multi-select/multi-select.component";

export default function UDFComponent() {

  const UDF_TYPE = ['Text', 'Number', 'Dropdown'];
  let type;

  return {
    oninit: (vnode) => {
      type = (vnode.attrs.type && UDF_TYPE.includes(vnode.attrs.type)) ? vnode.attrs.type : UDF_TYPE[0];
    },
    view: (vnode) => {
      return [
        type && [
          type === 'Number'
            ? m('input.form-control[type=number]', { onchange: vnode.attrs.onChange, value: vnode.attrs.value })
            : type === 'Dropdown'
              ? m(MultiSelectComponent, {
                items: vnode.attrs.items ?? [],
                selectedItems: vnode.attrs.value,
                itemKey: 'valueId',
                keyOnly: true,
                onSelect: vnode.attrs.onChange
              })
              : m('input.form-control', { onchange: vnode.attrs.onChange, value: vnode.attrs.value })
        ]
      ]
    }
  }
}
